module.exports = __webpack_public_path__ + "img/testimonials-icon-green2.c83d5454.svg";